// extracted by mini-css-extract-plugin
export default {"TruncatedCell":"TruncatedCell__JqOMWbUbiVyt"};